export default __webpack_public_path__ + "static/media/image-landing-page.64daee0e.jpg";